import { styled } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledPreviewAudio = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const StyledAudioPlayer = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 1;
  border-radius: 16px;
  padding: 12px 16px;
  border-width: 1px;
  background-color: ${COLOR.white};
  border: 1px solid ${COLOR.lightDivider};
  width: 529px;
  box-sizing: border-box;
  height: 72px;
  max-width: 100%;
`;

const StyledAudioInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledNoiseReductionToggle = styled('div')`
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 12px;
  padding: 12px 16px;
  border-top-width: 1px;
  background-color: ${COLOR.infoNoiseReduction};
  width: 529px;
  height: 48px;
  box-sizing: border-box;
  max-width: 100%;

  .info-rounded-icon {
    width: 16px;
    height: 16px;
    color: ${COLOR.loadingLoadRequest};
  }
`;

export {
  StyledPreviewAudio,
  StyledAudioPlayer,
  StyledAudioInfo,
  StyledNoiseReductionToggle,
};
